module.exports = __webpack_public_path__ + "img/38-2.76697fdf.jpg";